(function($) {
	
	$('.esrb-form .all').on('change', function(event) {
		event.preventDefault();
		$(this).closest('.fieldfroup').find('input[type="checkbox"]');
	});

	$('.esrb-form select').select2();

})(jQuery);